export const LOYALTY_APP_DEFINITION_ID = '553c79f3-5625-4f38-b14b-ef7c0d1e87df';
export const LOYALTY_APP_SECTION_ID = '86935446-7375-473b-8461-2be576b17182'; // Loyalty OOI page
export const REFERRALS_APP_DEFINITION_ID = '58be0514-fc10-4eb1-886e-2909d18f33b3';
export const REFERRALS_APP_SECTION_ID = 'wix-referrals-referral'; // Referrals landing page
